import React, { memo, useCallback } from 'react';
import PropTypes from 'prop-types';
import { get, omit } from 'lodash-es';
import Input from 'reactstrap/lib/Input';
import Label from 'reactstrap/lib/Label';
import { EventToolbox } from 'client/utils/event-toolbox';
import { TrackingConstant } from 'client/tracking/constant';
import { srpLinkBuilderWithParamsConversion } from 'site-modules/shared/utils/srp-link-constructor';
import captivePortalIcon from 'client/images/shop-5067/captive-portal.svg';

const LOCAL = 'local';
const LOCAL_LISTINGS_LABEL_STYLE = { whiteSpace: 'nowrap', paddingRight: '12px' };
const BUY_ONLINE_PROMO_STYLE = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: '0.375rem',
  minHeight: '36px',
  margin: '0 -1rem',
  padding: '8px 12px',
  fontSize: '14px',
  textAlign: 'center',
  textDecoration: 'none',
};
const BUY_ONLINE_ARROW_STYLE = { flexShrink: 0, marginLeft: '2px' };

export const SrpLocalListingsCheckbox = memo(({ selectedFacets, onUpdate }) => {
  const checked = get(selectedFacets, 'deliveryType[0]') === LOCAL;
  const handleChange = useCallback(() => {
    EventToolbox.fireTrackAction({
      event_type: TrackingConstant.EVENT_TYPE_ACTION_COMPLETED,
      event_data: {
        creative_id: 'edm-entry-local-listings',
        action_category: TrackingConstant.USER_ACTION_CATEGORY,
        action_cause: 'link_click',
        action_name: TrackingConstant.VIEW_SEARCH_RESULT,
        subaction_name: TrackingConstant.FILTER_SEARCH_RESULT,
        value: 'deliveryType~local~Only show local listings',
      },
    });
    onUpdate('deliveryType', { name: 'Only show local listings', value: LOCAL }, !checked);
  }, [checked, onUpdate]);

  return (
    <Label
      className="shop-5067-srp-top-local-listings-checkbox d-flex align-items-center mb-0 size-14"
      style={LOCAL_LISTINGS_LABEL_STYLE}
    >
      <Input type="checkbox" checked={checked} onChange={handleChange} className="me-0_5" />
      Only show local listings
    </Label>
  );
});

SrpLocalListingsCheckbox.propTypes = {
  selectedFacets: PropTypes.shape({}),
  onUpdate: PropTypes.func.isRequired,
};

export const SrpBuyOnlinePromo = memo(({ selectedFacets }) => {
  const href = srpLinkBuilderWithParamsConversion(omit(selectedFacets, 'deliveryType'), true);
  const handleClick = useCallback(() => {
    EventToolbox.fireTrackAction({
      event_type: TrackingConstant.EVENT_TYPE_ACTION_COMPLETED,
      event_data: {
        creative_id: 'edm-entry-buy-online-promo',
        action_category: TrackingConstant.USER_ACTION_CATEGORY,
        action_cause: 'link_click',
        action_name: TrackingConstant.VIEW_SEARCH_RESULT,
        subaction_name: 'visit_buy_online_channel',
      },
    });
  }, []);

  return (
    <a
      className="shop-5067-srp-top-buy-online-promo"
      href={href}
      rel="nofollow"
      onClick={handleClick}
      style={BUY_ONLINE_PROMO_STYLE}
    >
      <img
        src={captivePortalIcon}
        alt=""
        aria-hidden="true"
        width={14}
        height={14}
        style={{ display: 'block', flex: '0 0 14px' }}
      />
      <strong>Want to buy online?</strong>
      <span>View inventory</span>
      <span className="icon-arrow-right8 size-16" aria-hidden style={BUY_ONLINE_ARROW_STYLE} />
    </a>
  );
});

SrpBuyOnlinePromo.propTypes = {
  selectedFacets: PropTypes.shape({}),
};
